
import React from 'react';
import CryptoJS from "crypto-js";
import { SECRET_KEY, GoToCheckout, addToFavorites } from "../Functions"; // Keep the import for addToFavorites
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function VoucherCard({ product, isFavorite, removeFromFavorites }) {
    const navigate = useNavigate();

    const RedirectToProduct = (serviceId, productId) => {
        const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify({ serviceId, productId }),
            SECRET_KEY
        ).toString();

        navigate(`/product?data=${encodeURIComponent(encryptedData)}`);
    };

    const handleFavoriteClick = () => {
        addToFavorites(product);  // Call addToFavorites function which handles adding/removing
        removeFromFavorites(product.id); // Immediately remove the card from the UI
    };

    return (
        <div data-aos="flip-up"
            className='voucher_card p-2 bg_grey_light br_10 d-flex flex-row gap-3 mb-1'>
            {/* <LazyLoadImage
                effect="blur"
                className='br_10'
                src={product?.image || 'https://via.placeholder.com/150'}
                alt={product?.name}
            /> */}

            <LazyLoadImage
                effect="blur"
                className="br_10"
                src={product?.image || 'https://via.placeholder.com/150'}
                alt={product?.name || 'Voucher Image'}
                width="100"  // Set a reasonable width
                height="100" // Set a reasonable height
                
            />

            <div className='d-flex flex-column justify-content-between w-100'>
                <div className='d-flex flex-row justify-content-between gap-4 w-100'>
                    <p className='text-dark'>{product?.name || 'Unknown Voucher'}</p>
                    {isFavorite ? (
                        <h3 style={{ cursor: 'pointer', color: '#6D4EEC' }} onClick={handleFavoriteClick}>
                            ❤︎
                        </h3>
                    ) : ""}
                </div>
                <h5 className='bold'>
                    {typeof product?.prices?.retail?.amount === "object" && product?.prices?.retail?.amount?.min !== undefined
                        ? `$${product?.prices?.retail?.amount?.min} - $${product?.prices?.retail?.amount?.max}`
                        : `$${product?.prices?.retail?.amount || 'N/A'}`}
                </h5>

                <div className='d-flex w-100 gap-3 flex-wrap'>
                    <button
                        onClick={() => GoToCheckout(product)}
                        className='buy_button bold'>
                        Buy
                    </button>

                    <button className='view_button bold'
                        onClick={() => RedirectToProduct(product?.service?.id, product?.id)}
                    >View</button>
                </div>
            </div>
        </div>
    );
}
